/* Fetches & validates data for a session*/

import { getCookie } from '@jouzen/ecom-utils';

import { type Partner, type PartnerConfig } from '@/configs/partner';
import { Account, Order } from '@/types';
import { ApiError } from '@/types/Error';

import { mocks } from '../../../mocks/apiMocks';
import { checkEligibility } from './checkEligibility';
import getIsOrderComplete from './getIsOrderComplete';
import { getOrders } from './getOrders';

interface FetchSessionResponse {
  data?: {
    order?: Order;
    account?: Account;
  };
  error?: ApiError | unknown;
}

export const fetchSessionData = async (
  email: string,
  emailToken: string | null,
  partner: Partner,
  partnerConfig: PartnerConfig,
): Promise<FetchSessionResponse> => {
  try {
    const MOCK_DATA = getCookie('mock')?.toUpperCase();
    if (partnerConfig.checkEligibility) {
      const response = await checkEligibility(emailToken!, email);
      if (!response.eligible) return {};
    }
    if (partnerConfig.getOrders) {
      const response = MOCK_DATA
        ? mocks[MOCK_DATA].getOrders
        : await getOrders(email, emailToken, partner);

      if (response?.error) return { error: response.error };
      if (partnerConfig.hydrateOrderState) {
        return {
          data: {
            account: { orders: response.data ?? [] },
            order:
              response.data && response.data[0]
                ? {
                    ...response.data[0],
                    orderComplete: getIsOrderComplete(response.data[0]),
                  }
                : undefined,
          },
        };
      }

      return { data: { account: { orders: response.data } } };
    } else return {};
  } catch (error) {
    return { error };
  }
};
